import component from './GuestsRoomsChildren';

export default component;
